module.exports = "<div>\r\n    <furniture-page-content></furniture-page-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail2024/page/page-content.html
// module id = 194
// module chunks = 0